import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-anghywir',
    templateUrl: './anghywir.component.html',
    styleUrls: ['./anghywir.component.scss'],
    imports: [FaIconComponent]
})
export class AnghywirComponent implements OnInit {

  codGwall: number;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.codGwall = data.codGwall;
    });
  }
}
